import queryString, { ParsedQuery } from 'query-string';
import { ThemeVariationType } from '@graphql/generated';
import { FilterList } from '../../components/FilterBase';
import { PhotoCount, ThemeVariant } from './Template.types';
import { PHOTO_PRESENTATION_CONFIG } from '@shared/utils/photoPresentationLayout';

export const getFilterGroupIndex = (filterItems: FilterList[], groupLabel: string): number => {
  const group = filterItems.find(item => item.label === groupLabel) || filterItems[0];

  return filterItems.indexOf(group);
};

// Since template don't have own ID and designed on the basis of theme and layout, So we use themeId and layoutId for favorite template
export const getTemplateId = (variantThemeId?: string | null, variationType?: ThemeVariationType | string | null) => `${variantThemeId}-${variationType}`;
export const getResourceIds = (themeVariant?: ThemeVariant) => {
  const resourceId = themeVariant?.theme?.id;
  const secondaryResourceId =
    themeVariant?.theme?.designLayouts?.find(
      layout => (layout.layoutType === 'aloha' && themeVariant?.variationType === 'aloha') || (layout.layoutType === 'brannan' && themeVariant?.variationType === 'brannan'),
    )?.id ?? themeVariant?.theme?.designLayouts?.[0]?.id;
  return { resourceId, secondaryResourceId };
};

export const getGuestSitePreviewUrl = (eventHandle: string, template: ThemeVariant, currentQueryParams: ParsedQuery<string>, templateDataString?: string) => {
  const resultUrl = queryString.parseUrl(`/${eventHandle}/welcome?view=draft`);
  const queryParams = resultUrl.query;
  const { variationType: layout, font, theme, websiteDesignSettings } = template;
  theme?.themeId && (queryParams.theme = theme.themeId);
  layout && (queryParams.layout = layout);
  font && (queryParams.font = font);
  // Eventually all the query param will be passed in the templateDataString to reduce the number of query params
  templateDataString && (queryParams.templateData = templateDataString);

  if (websiteDesignSettings) {
    const { colorPalette, pageTransparency, pageShadow, photoPresentationLayout } = websiteDesignSettings;
    if (colorPalette) {
      queryParams.bc = colorPalette.artBackground;
      queryParams.pc = colorPalette.pageBackground;
      queryParams.pfc = colorPalette.pageFont;
      queryParams.lc = colorPalette.linkAndButton;
      queryParams.tc = colorPalette.artFont;
    }
    if (typeof pageTransparency === 'boolean') {
      queryParams.pt = pageTransparency.toString();
    }
    if (typeof pageShadow === 'boolean') {
      queryParams.ps = pageShadow.toString();
    }

    if (photoPresentationLayout) {
      queryParams.pl = photoPresentationLayout;
    }
  } else if (layout === 'brannan') {
    // Brannan layout
    queryParams.pl = 'center';
  }
  if (Object.keys(currentQueryParams).length > 0) {
    Object.keys(currentQueryParams).forEach(key => {
      queryParams[key] = currentQueryParams[key];
    });
  }

  return queryString.stringifyUrl(resultUrl);
};

export const getTemplatePhotoCount = (template: ThemeVariant): string => {
  const layout = template.websiteDesignSettings?.photoPresentationLayout;

  if (!layout) {
    // Old templates do not have photo presentation layout and has one photo by default
    return PhotoCount.One;
  }

  const config = PHOTO_PRESENTATION_CONFIG[layout];
  if (config) {
    // Return the minimum required photos
    if (config.max >= 2) return PhotoCount.TwoOrMore;
    return `${config.max}`;
  }

  return PhotoCount.Zero;
};
